// Import app css
import './index.scss';

//
import 'modernizr';

// Elements
import './elements/accordion';
import './elements/calendar';
import './elements/cookies-warning';
import './elements/edit-in-place';
import './elements/loader';
import './elements/modal';
import './elements/select';
import './elements/tabs';
import './elements/video';
import './elements/ekomi-widget-warning'

// Modules
import './modules/box-slider';
import './modules/discounts-map';
import './modules/features';
import './modules/form-standard';
import './modules/get-member';
import './modules/header';
import './modules/installation';
import './modules/main-slider';
import './modules/operations';
import './modules/parking-directory';
import './modules/plan-tabs';
import './modules/price-simulator';
import './modules/process-steps';
import './modules/site-map';
import './modules/testimonial';

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      var len = o.length >>> 0;

      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      var thisArg = arguments[1];

      var k = 0;

      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        k++;
      }

      return undefined;
    },
    configurable: true,
    writable: true
  });
}

// Polyfill para Object.assign (IE por problema en geolocalización)
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource !== null && nextSource !== undefined) {
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}




// WEBPACK FOOTER //
// ./app/ui/index.js